import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "currentLabel"]

  connect() {
    if (this.hasLinkTarget) this.select(this.linkTargets[0])
  }

  activate(event) {
    this.select(event.currentTarget)
  }

  synchronize(event) {
    if (!candidateDetailsFrame(event.target)) return

    const responseUrl = event.detail?.fetchResponse?.response?.url || event.target.src
    if (!responseUrl) return

    const responsePath = new URL(responseUrl, window.location.origin).pathname
    const activeLink = this.linkTargets.find((link) => new URL(link.href).pathname === responsePath)
    if (activeLink) this.select(activeLink)
  }

  select(activeLink) {
    const activePath = new URL(activeLink.href, window.location.origin).pathname
    this.linkTargets.forEach((link) => {
      const selected = new URL(link.href, window.location.origin).pathname === activePath
      link.classList.toggle("active", selected)
      if (selected) link.setAttribute("aria-current", "page")
      else link.removeAttribute("aria-current")
    })

    if (this.hasCurrentLabelTarget) {
      this.currentLabelTarget.textContent = activeLink.dataset.sectionLabel
    }
  }
}

function candidateDetailsFrame(frame) {
  return frame?.id === "candidate_details"
}
